<template>
  <section-main>
    <section-title title="my" />
    <heading-animated class="opening" :lines="['jesteśmy', 'niezależnym', 'Creative', 'SPOT\'em']" />
    <div class="copy-col copy-col-5 copy-col-5--first">
      <p class="copy">miejscem, w&nbsp;którym stawiamy na&nbsp;tworzenie kreacji i&nbsp;idei kreatywnej jako “must have” każdego projektu.</p>
      <p class="copy copy--lead copy--lead-first"><text-highlight>creativity<br>first</text-highlight></p>
      <p class="copy copy--lead"><text-highlight>execution<br>paramount</text-highlight></p>
      <p class="copy">Dla nas kreatywność jest kluczem do zwycięstwa wraz z&nbsp;zakończoną sukcesem realizacją</p>
    </div>
    <div class="copy-col copy-col-10 copy-col-10--right">
      <div class="copy copy--lead copy--right">
        <section-title
          class="section-title--rotated"
          title="filozofia"
        />
        <text-highlight>Chcemy<br>wykorzystywać<br>nasze doświadczenie<br>i&nbsp;dzielić&nbsp;się&nbsp;nim<br>z&nbsp;naszymi Klientami</text-highlight>
      </div>
    </div>
    <div class="copy-cols-wrap">
      <div class="copy-col copy-col-8">
        <p class="copy">Dlatego działamy wrażeniowo, emocjonalnie oraz profesjonalnie w&nbsp;3&nbsp;kluczowych obszarach:</p>
      </div>
      <div class="copy-col copy-col-3">
        <copy-list />
      </div>
    </div>
    <div class="copy-col">
      <brands/>
    </div>
    <heading-animated :lines="['dostarczamy', 'efekt', 'wow']" />
    <div class="copy-col copy-col-5">
      <p class="copy">Efekt WOW to wartość łącząca nasze obszary biznesu i&nbsp;efekt, który dostarczamy na każdym etapie współpracy.</p>
      <p class="copy">Od pomysłu, przez kreacje, na realizacji i&nbsp;podsumowaniu wyników kończąc.</p>
    </div>
  </section-main>
</template>

<script>
import HeadingAnimated from '@/components/HeadingAnimated'
import SectionTitle from '@/components/SectionTitle'
import TextHighlight from '@/components/TextHighlightAnimation/TextHighlight'
import CopyList from '@/components/CopyList'
import Brands from '@/components/Brands'
export default {
  components: {
    HeadingAnimated,
    SectionTitle,
    TextHighlight,
    CopyList,
    Brands
  }
}
</script>

<style lang="scss" scoped>
  .section-about {
    .copy-col-8 .copy {
      @include font-style-big-smaller;
      text-transform: uppercase;
      padding-right: 1em;
      @include media-up(lg) {
        @include font-style-medium-bigger;
        text-transform: none;
      }
    }
    .copy-col-5 {
      @include media-up(sm) {
        width: 305px;
      }
      @include media-up(lg) {
        width: 584px;
      }
      .copy {
        margin-bottom: 2em;
      }
      &--first {
        margin-right: 40px;
        @include media-up(sm) {
          margin-right: 0;
        }
        .copy:first-of-type {
          margin-bottom: 46px;
          @include media-up(sm) {
            margin-bottom: 69px;
          }
        }
        .copy:last-of-type {
          margin-top: 72px;
          @include media-up(sm) {
            margin-top: 68px;
          }
        }
        .copy--lead-first {
          margin-bottom: 43px;
        }
      }
    }
    .copy-col-10 {
      margin-top: 86px;
      margin-bottom: 115px;
      p {
        margin-top: 0;
        margin-bottom: 0;
      }
      @include media-up(sm) {
        margin-top: 123px;
        margin-bottom: 112px;
      }
      @include media-up(md) {
        margin-top: 60px;
        margin-bottom: 97px;
      }
      @include media-up(lg) {
        margin-top: 246px;
        margin-bottom: 299px;
      }
    }
    .copy-cols-wrap {
      justify-content: space-between;
      .copy-col:first-of-type {
        margin-bottom: 57px;
        @include media-up(sm) {
          margin-bottom: 90px;
        }
        @include media-up(md) {
          margin-bottom: 0;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/About.vue